import { STATIC_STRINGS } from "@asez/shared";
import { FILTER_KEYS } from "@asez/shared";
import { FilterListItem } from "./FilterListItem";
import { initialFilters } from "./index";

const StatusOptions = STATIC_STRINGS.STATUS_OPTIONS;

export const StatusFilter = ({ filters, updateFilters }) => {
  return (
    <FilterListItem
      filterName={STATIC_STRINGS.USER_STATUS}
      resetHandler={() => {
        updateFilters(
          FILTER_KEYS.USER_STATUS,
          initialFilters[FILTER_KEYS.USER_STATUS]
        );
      }}
      Component={
        <div className="flex justify-start items-center w-full">
          {StatusOptions.map((status) => (
            <div
              key={status}
              className={`p-2 mr-2 rounded-lg text-sm font-medium transition duration-300 border-2 border-neutral-dark text-primary hover:bg-neutral hover:text-white cursor-pointer ${
                filters[FILTER_KEYS.USER_STATUS] === status &&
                `text-white bg-neutral-dark`
              }`}
              onClick={() => updateFilters(FILTER_KEYS.USER_STATUS, status)}
            >
              {status}
            </div>
          ))}
        </div>
      }
    />
  );
};
